export const INTERNAL = 'internal'
export const EXTERNAL = 'external'
